import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Safe JSON parser
  const safeParse = (key) => {
    try {
      const value = localStorage.getItem(key);
      if (!value || value === "undefined") return null; 
      return JSON.parse(value);
    } catch (err) {
      console.error("Error parsing localStorage:", err);
      return null;
    }
  };

  // Auth state
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isAuthenticated") === "true"
  );

  const [authData, setAuthData] = useState(() => safeParse("authData"));

  // Login → save user data
  const login = (data) => {
    localStorage.setItem("isAuthenticated", "true");
    if (data) {
      localStorage.setItem("authData", JSON.stringify(data));
      setAuthData(data);
    }
    setIsAuthenticated(true);
  };

  // Logout → clear user data
  const logout = () => {
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("authData");
    setAuthData(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, authData, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthdata = () => useContext(AuthContext);
